module.exports = __webpack_public_path__ + "static/img/1.b91deb6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/15/eng/1.png
// module id = fsjk
// module chunks = 0